function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Shop = function Shop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M11.67 1a6.014 6.014 0 0 1 5.987 5.52h.956c1.577 0 2.908 1.204 3.03 2.741l.901 11.376c.003 1.169-.898 2.055-2.006 2.055H3.01C1.901 22.692 1 21.806 1 20.716l.904-11.455c.122-1.537 1.453-2.741 3.03-2.741h.75A6.014 6.014 0 0 1 11.67 1m6.943 7.52H4.934c-.54 0-.996.396-1.036.899l-.893 11.268 17.533.005h.004L19.65 9.419c-.04-.503-.495-.899-1.036-.899M11.67 3a4.01 4.01 0 0 0-3.976 3.52h7.953A4.01 4.01 0 0 0 11.67 3"
  }));
};
export default Shop;